import {
  AutocompleteInput,
  ReferenceInput,
  TextInput,
} from "react-admin";

const restockPlanFilterList = (permissions) => {
  const defaultFilter = [
    <TextInput
      resettable
      alwaysOn
      source="code"
      variant="outlined"
      label="mine.label.code"
    />,
    <AutocompleteInput
    resettable
    source="month"
    variant="outlined"
    label="mine.label.month"
    alwaysOn
    choices={[
      { id: "1", name: "Jan" },
      { id: "2", name: "Feb" },
      { id: "3", name: "Mar" },
      { id: "4", name: "Apr" },
      { id: "5", name: "Mei" },
      { id: "6", name: "Jun" },
      { id: "7", name: "Jul" },
      { id: "8", name: "Aug" },
      { id: "9", name: "Sep" },
      { id: "10", name: "Oct" },
      { id: "11", name: "Nov" },
      { id: "12", name: "Dec" },
    ]}
  />,
    <TextInput
      resettable
      alwaysOn
      source="year"
      variant="outlined"
      label="mine.label.year"
    />,
  ];
  if (permissions && permissions.update_company) {
    defaultFilter.splice(
      1,
      0,
      <ReferenceInput
        alwaysOn
        source="company_id"
        reference="companies"
        sort={{ field: "companies.alias", order: "ASC" }}
      >
        <AutocompleteInput
          resettable
          optionText="alias"
          variant="outlined"
          label="mine.label.company"
        />
      </ReferenceInput>
    );
  }
  return defaultFilter;
};
export default restockPlanFilterList;
